export default "//file.bilionpass.com/japandx-web/0.0.1/static/num_04.a5642a2e-1aaada.svg";